import { render, staticRenderFns } from "./AddNoteShared.vue?vue&type=template&id=7a879524&scoped=true"
import script from "./AddNoteShared.vue?vue&type=script&lang=js"
export * from "./AddNoteShared.vue?vue&type=script&lang=js"
import style0 from "./AddNoteShared.vue?vue&type=style&index=0&id=7a879524&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a879524",
  null
  
)

export default component.exports